export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 p-8 md:p-12 rounded-2xl bg-background-100 border border-background-200/70">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-600 text-xs font-medium mb-4">
              <i className="ri-smartphone-line"></i>
              移动端专属优化
            </div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              随时随地，下拉式追漫
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-[560px] mx-auto lg:mx-0">
              女神漫画下拉式阅读专为手机触摸屏打造。无需下载 App，打开浏览器即可享受流畅的下拉式漫画阅读体验。
              躺在床上、通勤路上、排队等待 — 碎片时间也能追完整话，韩漫日漫全集随时随地免费畅读。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-compass-3-line"></i>
                立即开始阅读
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-8 py-3 border border-background-300 text-foreground-700 font-medium rounded-full hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-information-line"></i>
                了解下拉式特色
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-[240px] h-[400px] md:w-[280px] md:h-[460px] rounded-[2rem] overflow-hidden border-4 border-background-300 bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20manga%20reading%20app%20screen%2C%20Korean%20webtoon%20style%20vertical%20scrolling%20comic%20on%20phone%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20clean%20UI%20design%2C%20one%20hand%20holding%20phone%2C%20cozy%20atmosphere%2C%20digital%20illustration&width=600&height=1000&seq=app-mockup-manga&orientation=portrait"
                alt="女神漫画下拉式手机阅读界面展示"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}